import { RoutePermittedRole } from 'constants/AppConst';
import ListApp from './ListApp';
import { ROUTE_STRING } from 'constants/RouteString';
import Edit from './components/Edit';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';

export const listAppRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.LIST_APP.LIST, ROUTE_STRING.LIST_APP.DETAIL],
    element: (
      <AllowedAccess
        isPageFailed
        permissionIds={[AuthorizePermission.APP_READ]}
      >
        <ListApp />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.LIST_APP.EDIT],
    element: (
      <AllowedAccess
        isPageFailed
        permissionIds={[
          AuthorizePermission.APP_GENERAL_INFORMATION_UPDATE,
          AuthorizePermission.APP_DESCRIPTION_UPDATE,
          AuthorizePermission.APP_CONFIGURATION_UPDATE,
          AuthorizePermission.APP_PRICING_UPDATE,
          AuthorizePermission.APP_PRICING_UPDATE_KEY_FEATURE,
          AuthorizePermission.APP_PRICING_READ,
        ]}
      >
        <Edit />
      </AllowedAccess>
    ),
  },
];
